/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/
import { ExcludePaginationNodeTypes } from '@/constants'

const nodeUtilities = (function () {
    const isNodeTypeExists = (nodeType: string): boolean => {
        const nodeTypes = Object.keys(ExcludePaginationNodeTypes)
        return nodeTypes.includes(nodeType)
    }

    return {
        isNodeTypeExists,
    }
})()

export default nodeUtilities
